@if (!hideButtons()) {
    <button class="action-btn" [ariaLabel]="reduceLabel()" [disabled]="disabledDecrement()" (click)="decrement()">
        <mat-icon svgIcon="ico_minus_outlined"></mat-icon>
    </button>
}
<span class="counter-value body-1">{{ modifiedCount() }}</span>
@if (!hideButtons()) {
    <button class="action-btn" [ariaLabel]="increaseLabel()" [disabled]="disabledIncrement()" (click)="increment()">
        <mat-icon svgIcon="ico_plus_outlined"></mat-icon>
    </button>
}
